(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./inapp", "./types", "./utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./inapp"), require("./types"), require("./utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.inapp, global.types, global.utils);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _inapp, _types, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    filterHiddenInAppMessages: true,
    sortInAppMessages: true
  };
  Object.defineProperty(_exports, "filterHiddenInAppMessages", {
    enumerable: true,
    get: function () {
      return _utils.filterHiddenInAppMessages;
    }
  });
  Object.defineProperty(_exports, "sortInAppMessages", {
    enumerable: true,
    get: function () {
      return _utils.sortInAppMessages;
    }
  });
  Object.keys(_inapp).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _inapp[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function () {
        return _inapp[key];
      }
    });
  });
  Object.keys(_types).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _types[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function () {
        return _types[key];
      }
    });
  });
});